// Mapping bekannter deutscher Netzbetreiber → Installateurportal-URLs.
// Suche ist case-insensitive und tolerant gegenüber Abkürzungen / Zusätzen.
const PORTALS = [
  { keys: ["netze bw", "netzebw"], url: "https://www.netze-bw.de/installateure" },
  { keys: ["bayernwerk"], url: "https://www.bayernwerk-netz.de/de/fuer-installateure.html" },
  { keys: ["westnetz", "e.on westnetz"], url: "https://iam.westnetz.de/" },
  { keys: ["avacon"], url: "https://www.avacon-netz.de/de/fuer-partner/installateure.html" },
  { keys: ["e.dis", "edis"], url: "https://www.e-dis-netz.de/de/installateure/" },
  { keys: ["mitnetz"], url: "https://www.mitnetz-strom.de/installateure" },
  { keys: ["sachsennetze", "enso"], url: "https://www.sachsennetze.de/geschaeftskunden/netzanschluss/installateure/" },
  { keys: ["stromnetz berlin", "vattenfall berlin"], url: "https://www.stromnetz.berlin/installateure" },
  { keys: ["stromnetz hamburg"], url: "https://www.stromnetz-hamburg.de/installateure" },
  { keys: ["swm", "stadtwerke münchen", "stadtwerke muenchen"], url: "https://www.swm-infrastruktur.de/geschaeftspartner/installateure" },
  { keys: ["lew"], url: "https://www.lew-verteilnetz.de/installateurportal" },
  { keys: ["netze mitte", "netzemitte"], url: "https://www.netze-mitte.de/" },
  { keys: ["rheinnetz", "rhein-netz"], url: "https://www.rhein-netz.de/" },
  { keys: ["syna"], url: "https://www.syna.de/installateure" },
  { keys: ["schleswig-holstein netz", "sh netz"], url: "https://www.sh-netz.com/de/fuer-partner/installateure.html" },
  { keys: ["hansewerk"], url: "https://www.hansewerk.com/de/fuer-partner/installateure.html" },
  { keys: ["enercity"], url: "https://www.enercity-netz.de/geschaeftskunden/installateur-und-planer/index.html" },
  { keys: ["mainz netze", "mainzer netze"], url: "https://www.mainzer-netze.de/geschaeftskunden/installateure" },
  { keys: ["rwn", "rheinwaldnetze"], url: "https://www.rheinwaldnetze.de/" },
  { keys: ["stadtwerke"], url: "https://www.google.com/search?q=Installateurportal+" },
];

export function getPortalUrl(netzbetreiber) {
  if (!netzbetreiber) return null;
  const s = netzbetreiber.toLowerCase().trim();
  for (const p of PORTALS) {
    if (p.keys.some((k) => s.includes(k))) {
      if (p.url.endsWith("=")) return p.url + encodeURIComponent(netzbetreiber);
      return p.url;
    }
  }
  return `https://www.google.com/search?q=${encodeURIComponent("Installateurportal " + netzbetreiber)}`;
}

// Grobe PLZ-Prefix → Netzbetreiber Ermittlung für die häufigsten deutschen VNBs.
// Basiert auf 2-stelligem PLZ-Präfix. In Grenzgebieten kann der tatsächliche
// Netzbetreiber abweichen (z. B. Stadtwerke). Immer als Vorschlag behandeln.
const PLZ_TO_NETZBETREIBER = {
  "01": "SachsenNetze", "02": "SachsenNetze",
  "03": "E.DIS Netz", "04": "Mitnetz Strom", "05": "Mitnetz Strom",
  "06": "Mitnetz Strom", "07": "TEN Thüringer Energienetze",
  "08": "Mitnetz Strom", "09": "Mitnetz Strom",
  "10": "Stromnetz Berlin", "11": "Stromnetz Berlin", "12": "Stromnetz Berlin",
  "13": "Stromnetz Berlin", "14": "E.DIS Netz", "15": "E.DIS Netz", "16": "E.DIS Netz",
  "17": "E.DIS Netz", "18": "WEMAG Netz", "19": "WEMAG Netz",
  "20": "Stromnetz Hamburg", "21": "Stromnetz Hamburg", "22": "Stromnetz Hamburg",
  "23": "Schleswig-Holstein Netz", "24": "Schleswig-Holstein Netz", "25": "Schleswig-Holstein Netz",
  "26": "EWE Netz", "27": "EWE Netz", "28": "wesernetz Bremen", "29": "Avacon Netz",
  "30": "enercity Netz", "31": "Avacon Netz", "32": "Westnetz", "33": "Westnetz",
  "34": "EAM Netz", "35": "EAM Netz", "36": "TEN Thüringer Energienetze",
  "37": "EAM Netz", "38": "Avacon Netz", "39": "Avacon Netz",
  "40": "Westnetz", "41": "Westnetz", "42": "Westnetz", "43": "Westnetz",
  "44": "Westnetz", "45": "Westnetz", "46": "Westnetz", "47": "Westnetz",
  "48": "Westnetz", "49": "Westfalen Weser Netz",
  "50": "Rheinnetz", "51": "Rheinnetz", "52": "Westnetz", "53": "Westnetz",
  "54": "Westnetz", "55": "Mainzer Netze", "56": "Syna", "57": "Westnetz",
  "58": "Westnetz", "59": "Westnetz",
  "60": "Netzdienste Rhein-Main", "61": "Syna", "62": "Syna", "63": "Syna",
  "64": "ENTEGA Netz", "65": "Syna",
  "66": "Pfalzwerke Netz", "67": "Pfalzwerke Netz",
  "68": "Netze BW", "69": "Netze BW",
  "70": "Netze BW", "71": "Netze BW", "72": "Netze BW", "73": "Netze BW",
  "74": "Netze BW", "75": "Netze BW", "76": "Netze BW", "77": "Netze BW",
  "78": "Netze BW", "79": "Netze BW",
  "80": "SWM Infrastruktur", "81": "SWM Infrastruktur",
  "82": "Bayernwerk Netz", "83": "Bayernwerk Netz", "84": "Bayernwerk Netz",
  "85": "Bayernwerk Netz", "86": "LEW Verteilnetz", "87": "LEW Verteilnetz",
  "88": "Netze BW", "89": "LEW Verteilnetz",
  "90": "N-ERGIE Netz", "91": "N-ERGIE Netz",
  "92": "Bayernwerk Netz", "93": "Bayernwerk Netz", "94": "Bayernwerk Netz",
  "95": "Bayernwerk Netz", "96": "Bayernwerk Netz",
  "97": "Mainfranken Netze", "98": "TEN Thüringer Energienetze",
  "99": "TEN Thüringer Energienetze",
};

// Städte, deren Netzbetreiber vom PLZ-Prefix abweicht (Stadtwerke).
const CITY_OVERRIDES = {
  "münchen": "SWM Infrastruktur", "muenchen": "SWM Infrastruktur",
  "nürnberg": "N-ERGIE Netz", "nuernberg": "N-ERGIE Netz",
  "leipzig": "Netz Leipzig",
  "dresden": "SachsenNetze",
  "hannover": "enercity Netz",
  "bremen": "wesernetz Bremen",
  "hamburg": "Stromnetz Hamburg",
  "berlin": "Stromnetz Berlin",
  "köln": "Rheinnetz", "koeln": "Rheinnetz",
  "düsseldorf": "Netzgesellschaft Düsseldorf", "duesseldorf": "Netzgesellschaft Düsseldorf",
  "stuttgart": "Stuttgart Netze",
  "frankfurt am main": "Netzdienste Rhein-Main", "frankfurt": "Netzdienste Rhein-Main",
  "mainz": "Mainzer Netze",
  "essen": "Westnetz",
  "dortmund": "DEW21",
  "duisburg": "Netze Duisburg",
};

export function detectNetzbetreiber(plz, ort) {
  const cityKey = (ort || "").toLowerCase().trim();
  if (cityKey && CITY_OVERRIDES[cityKey]) return CITY_OVERRIDES[cityKey];
  const p = String(plz || "").trim();
  if (p.length >= 2 && /^\d{2}/.test(p)) {
    return PLZ_TO_NETZBETREIBER[p.substring(0, 2)] || null;
  }
  return null;
}
